import TextIconGroupList from './TextIconGroupList';
import { TextIconGroupListProps, TextIconGroupListValueProps } from './types';

export type { TextIconGroupListProps, TextIconGroupListValueProps };
export default TextIconGroupList;
